import { API_BASE } from '../config';
import { getAuthToken } from '../utils/authStorage';

async function authHeaders() {
  const token = getAuthToken();
  if (!token) {
    throw new Error('No authentication token found');
  }
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
}

// STOCK MOVEMENTS
export async function fetchStockMovements(skip = 0, limit = 100, chemicalId = null) {
  const params = new URLSearchParams({
    skip: skip.toString(),
    limit: limit.toString(),
  });
  
  if (chemicalId) {
    params.append('chemical_id', chemicalId.toString());
  }
  
  const res = await fetch(`${API_BASE}/stock-movements/?${params}`, { 
    headers: await authHeaders() 
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to fetch stock movements');
  }
  return res.json();
}

export async function fetchStockMovement(id) {
  const res = await fetch(`${API_BASE}/stock-movements/${id}`, { 
    headers: await authHeaders() 
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to fetch stock movement');
  }
  return res.json();
}

export async function createStockMovement(data) {
  const res = await fetch(`${API_BASE}/stock-movements/`, {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to create stock movement');
  }
  return res.json();
}

export async function updateStockMovement(id, data) {
  const res = await fetch(`${API_BASE}/stock-movements/${id}`, {
    method: 'PATCH',
    headers: await authHeaders(),
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to update stock movement');
  }
  return res.json();
}

export async function deleteStockMovement(id) {
  const res = await fetch(`${API_BASE}/stock-movements/${id}`, {
    method: 'DELETE',
    headers: await authHeaders(),
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to delete stock movement');
  }
  return res.json();
}

export async function fetchStockMovementsByChemical(chemicalId) {
  const res = await fetch(`${API_BASE}/stock-movements/chemical/${chemicalId}`, { 
    headers: await authHeaders() 
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to fetch stock movements for chemical');
  }
  return res.json();
}

export async function fetchStockMovementsByAction(action) {
  const res = await fetch(`${API_BASE}/stock-movements/action/${action}`, { 
    headers: await authHeaders() 
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.detail || 'Failed to fetch stock movements by action');
  }
  return res.json();
}
